import { fromFetch } from 'rxjs/fetch';
import { switchMap, catchError, of } from 'rxjs';
import { articleSearchResults, articleCards } from 'constants/routes'

/**
 * Checks if the B1 styles are currently applied to the document.
 * This is a temporary check implemented during the ongoing rebrand process.
 * Once the rebrand is complete, this logic may be subject to change or removal.
 *
 * @returns {boolean} True if the B1 styles are present, otherwise false.
 */
const isB1Styles = () => !!document.querySelector('[data-b1-styles]');

/**
 * Sends a POST request to fetch article search results based on the provided payload.
 *
 * @function
 * @param {Object} payload - The payload containing the search command for blog articles.
 * @returns {Observable<string|Error>} An observable that emits the response text on success or an error on failure.
 */
const getArticleSearchResults$ = (payload) => {
  const requestObject = {
    method: 'POST',
    body: JSON.stringify({
      BlogArticlesSearchCommand: payload
    }),
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json'
    }
  };

  const url = isB1Styles() ? articleCards : articleSearchResults;
  return fromFetch(url, requestObject).pipe(
    switchMap((response) => response.text()),
    catchError((error) => of(error))
  );
}

export default getArticleSearchResults$;